import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CategoryService } from 'src/app/features/configrations/ingredients-category/services/Category.service';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import { Patterns } from 'src/app/helpers/patterns';
import { ListData, ListFilter, PageData, sortList } from '../../../models/List.Ingredient';
import { RestaurantIngredientService } from '../../../services/Ingredients.service';

export interface DialogData {
  selectedItems: any[],
  restaurantId: number
}
@Component({
  selector: 'app-ingredient-form',
  templateUrl: './ingredient-form.component.html'
})
export class IngredientFormComponent extends DirtyComponent implements OnInit {
  dataLoading = false;
  pageIndex = 0;
  pageSize = 20;
  pageCount = 0;
  recordsData!: ListData | null;
  filterModel: ListFilter = new ListFilter();
  dataList: PageData[] = [];

  restaurantIngredients: any[] = []
  selectedIngredients: any[] = []
  selectedIngredientsCopy: any = []

  lang = localStorage.getItem('language') || 'en';
  categoryList: any[] = [];
  categorySelected?: any;
  searchText?: any;
  noSpecialTxt = Patterns.noSpecialTxt;
  override formGroup!: FormGroup;

  subscriptions: Subscription[] = []

  constructor(
    private service: RestaurantIngredientService,
    override dialogRef: MatDialogRef<IngredientFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    translate: TranslateService,
    private categoryService: CategoryService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    super(translate)
  }
  ngAfterViewChecked() {
    //your code to update the model
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    this.filterModel.pageSize = this.pageSize;
    this.filterModel.restaurantId = this.data.restaurantId;
    this.getAll();
    this.subscriptions.push(
      this.service.refreshList.subscribe(data => {
        if (data) {
          this.getAll();
        }
      })
    )
    this.getCategories()

    this.restaurantIngredients = JSON.parse(JSON.stringify(this.data.selectedItems))
    this.restaurantIngredients.map((item, index) => {
      this.restaurantIngredients[index] = item.ingredient
    })
    this.selectedIngredientsCopy = JSON.parse(JSON.stringify(this.selectedIngredients))
  }


  ngOnDestroy() {
    this.service.refreshList.next(false);
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }


  override canDeactivate() {
    return (this.selectedIngredients.length !== this.selectedIngredientsCopy.length) || this.searchText || this.categorySelected;
  }


  getCategories() {
    this.categoryService.getAllCategory(this.data.restaurantId)
      .subscribe(
        (data: any) => {
          this.categoryList = data as [];
        }, (err: any) => {
          console.error(err);
        });
  }
  getNextPage() {
    if (this.pageIndex < this.pageCount - 1) {
      this.pageIndex += 1;
      this.getAll();
    }
  }

  selected(event?: any, item?: any) {
    if (event.checked) {
      this.selectedIngredients.push(item)
    } else {
      let findItem = this.selectedIngredients.findIndex(x => x.id == item.id)
      if (findItem != -1) {
        this.selectedIngredients.splice(findItem, 1)
      }
    }
  }
  makeFilter() {
    this.pageIndex = 0;
    this.dataList = [];
    this.getAll();
  }
  getAll() {
    if (this.pageIndex == 0) {
      this.dataLoading = true;
    }
    this.filterModel.pageNumber = this.pageIndex;
    this.filterModel.searchText = this.searchText;
    this.filterModel.categoryId = this.categorySelected;
    this.filterModel.restaurantId = this.data.restaurantId;

    this.service.GetIngredientForRestaurant(this.filterModel).subscribe(
      (data: ListData) => {
        this.dataLoading = false;
        if (data) {
          this.recordsData = data;
          this.pageCount = Math.ceil(this.recordsData.totalCount / this.filterModel.pageSize);
          if (data.pageData) {
            this.dataList = this.dataList.concat(data.pageData);
            this.dataList.map(item => {
              let findSelected = this.selectedIngredients.find(x => x.id == item.id);
              let findRestSelected = this.restaurantIngredients.find(x => x.id == item.id);

              item.canSelect = findRestSelected ? false : true
              item.isSelected = (findSelected || findRestSelected) ? true : false
            })
          }
        }
      },
      (error: any) => {
        this.recordsData = null;
        this.dataLoading = false;
      });
  }

  // hideOption(item: any) {
  //   // return this.searchText ? item.name.includes(this.searchText) === false : false;
  //   return this.searchText ? (item.title_AR.toLowerCase().includes(this.searchText.toLowerCase()) || item.title_EN.toLowerCase().includes(this.searchText.toLowerCase())) === false : false;
  // }
  // hideByCategory(item: any) {
  //   return this.categorySelected ? item.categoryId != this.categorySelected : false
  // }
  // isAllHidden() {
  //   return this.recordsData?.pageData.every(item => this.hideOption(item) || this.hideByCategory(item) || !item.canSelect);
  // }

  // hasRecordsData() {
  //   return (
  //     !this.isAllHidden() &&
  //     this.recordsData?.pageData
  //     && this.recordsData?.pageData?.length
  //     && this.restaurantIngredients.length != this.recordsData?.pageData?.length
  //   )
  // }

  saveRecord() {
    const selected = this.selectedIngredients.filter(item => item.isSelected);
    this.dialogRef.close(selected);
  }

}
